import classNames from 'classnames';
import SelectOptionCard, {
  SelectOptionCardProps,
} from '@/components/molecules/select-option-card/select-option-card';
import styles from './filter-card-list.module.scss';

type DisplayVariant = 'column' | 'row';

export interface FilterItem extends SelectOptionCardProps {
  id: string;
}

export interface FilterCardListProps {
  /** The class name to apply */
  className?: string;
  /** Indicates how the items are displayed on a row wrapped or column */
  displayVariant?: DisplayVariant;
  /** An array of the filter cards to show */
  items: FilterItem[];
  /** An event that is triggered on change */
  onChange?: (id: string) => void;
}

const variants: Record<DisplayVariant, string> = {
  column: styles.isColumn,
  row: styles.isRow,
};

const FilterCardList = ({
  className,
  displayVariant = 'column',
  items,
  onChange,
}: FilterCardListProps) => {
  return (
    <div
      className={classNames(
        styles.component,
        className,
        variants[displayVariant],
      )}
    >
      {items.map(item => (
        <SelectOptionCard
          key={item.id}
          headline={item.headline}
          icon={item.icon}
          isSelected={item.isSelected}
          onClick={() => onChange && onChange(item.id)}
        />
      ))}
    </div>
  );
};

FilterCardList.displayName = 'FilterCardList';

export default FilterCardList;
